module.exports = __webpack_public_path__ + "b42206f0043daa0e86deefc358255a4b.png";